import React from 'react'
import Text from '../../elements/Typo/Text'
import { useTranslation } from 'react-i18next'

const FieldValidation: React.FC = () => {
    const { t } = useTranslation()
    return (
        <div className="bg-[#FAF8EF] border border-[#0AD4E133] rounded-[0.45rem] mt-2">
            <Text size="lg" className="font-semibold p-2">
                {t('Validation:')}
            </Text>
            <div className="border-b border-[#0AD4E133]"></div>
            <Text size="md" className="p-2">
                {t('No Missing Values')}
            </Text>
        </div>
    )
}

export default FieldValidation
